import { render, staticRenderFns } from "./DMPData.vue?vue&type=template&id=707ace68&scoped=true"
import script from "./DMPData.vue?vue&type=script&lang=js"
export * from "./DMPData.vue?vue&type=script&lang=js"
import style0 from "./DMPData.vue?vue&type=style&index=0&id=707ace68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707ace68",
  null
  
)

export default component.exports